import {RefObject, useEffect, useState} from 'react';

export default function useHasOverflowX<T extends HTMLElement>(
  ref: RefObject<T | null>,
  deps: unknown[] = []
): boolean {
  const [hasOverflowX, setHasOverflowX] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const update = () => setHasOverflowX(element.scrollWidth > element.clientWidth);
    update();
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps]);

  return hasOverflowX;
}
